import React from 'react';
import Rating from '@mui/material/Rating';

const ReviewCard = ({ review }) => {
    return (
        <div className='reviewCard'>
            <img src='/assets/images/user.svg' alt='' />
            <div className='ps-3 mt-2'>
                <h6 className='fw-bold'>{review.name}</h6>
                <div>
                    <Rating size='large' precision={0.5} value={review.rating} readOnly />
                </div>
                <span>{review.comment}</span>
            </div>
        </div>
    );
};

export default ReviewCard;
